/*
* Created on Jan 25, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useRef, useState} from 'react';
import ModalComponent from "../common/ModalComonent/ModalComponent";
import ic_search_svg from "../../static/img/utils/ic-search.svg";
import ic_arrow_drop_down from "../../static/img/utils/ic-arrow-drop-down.svg";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {useOrganization} from "../../context/OrganizationContext";
import TextInputComponent from "../common/Form/TextInputComponent";
import {LENGTH_FORMAT, GROUP_DESCRIPTION_FORMAT} from "../../service/common";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../hook/OrganizationAPIHook";
import {useRegion} from "../../context/RegionContext";
import {useQueryClient} from "@tanstack/react-query";


const GroupCreateModalComponent = ({openModal, closeModal, doRefresh}) => {
    const {t, i18n} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const queryClient = useQueryClient();
    const {getCurrentOrg, setCurrentOrg} = useOrganization();
    // const {getCurrentOrg} = current_organization;
    const organization = getCurrentOrg();
    const [checkAll, setCheckAll] = useState(false);
    const [groupQueryFilter, setGroupQueryFilter] = useState("");
    const {url} = useRegion();
    const modal = useRef();

    let initial_values = {
        group_name: {value: '', error: null, required: true},
        description: {value: '', error: null, required: false},
    };

    const [input, setInput] = useState(initial_values);
    const [userList, setUserList]= useState(organization.users || []);

    const toggle_check_all = (e) => {
        if (e.target.checked) {
            setUserList((prev)=>{
                return prev.map(u=>{return {...u, checked: true}})
            });
            setCheckAll(true);
        }
        else {
            setUserList((prev)=>{
                return prev.map(u=>{return {...u, checked: false}})
            });
            setCheckAll(false);
        }
    }

    const onSubmit = async () => {
        console.log('Do submit')
        const data = {
            name: input.group_name.value,
            description: input.description.value
        }

        try {
            const result = await OrganizationAPI.post(`organization/${organization.organization_id}/group`, null, data);

            if (result) {
                const add_list = userList.filter(u => {
                    if (u.checked) {
                        return u;
                    }
                }).map((u) => (u.email));
                const new_group_id = result.result.group_id;
                await OrganizationAPI.post(
                    `organization/${organization.organization_id}/group/${new_group_id}/user`, null,
                    {emails: add_list});
            }

            const new_groups = await OrganizationAPI.get(`organization/${organization.organization_id}/group`);
            organization.groups = new_groups.result;
            setCurrentOrg(organization);
            queryClient.invalidateQueries({queryKey: [`organization/${organization.organization_id}/group`], refetchType: 'all'});
            doRefresh((prevVal) => prevVal + 1);
            closeModal();
        } catch (err) {
            const message = err.response?.data?.message || err.message;
            const code = err.response?.data?.code? err.response.data.code : err.code;
            modal.current.alert(true, 'error', code, message);
        }
    }

    // const toggleUserList = (list_type) => {
    //     setUserListType(list_type);
    //     if (list_type === '未邀請') {
    //         setUserList(uninvited_list);
    //     }
    //     else {
    //         setUserList(()=>{
    //             return group_data.users.map(u=>({...u, checked: true}))
    //         });
    //         // setUserList(group_data.users);
    //     }
    // }

    const onCheckBoxListChanged = () => {
        const test = userList.filter(u=>u.checked).length;
        const isFull = test === userList.length && userList.length > 0;
        setCheckAll(isFull);
    }

    const toggle_user_remove_list = (user) => {
        setUserList((prevUserList)=>{
            return prevUserList.map(u=>{
                if (u.id===user.id) {
                    return {...u, checked: !u.checked}
                }
                return u
            });
        });
        // setCheckAll(userList.filter(u=>u.checked).length === userList.length)
    }

    const get_status = (user_status) => {
        const status = user_status;
        switch (status) {
            case 'active':
                return ['Activate', 'status-color-green'];
            case 'pending':
                return ['Invited', 'status-color-royal-blue'];
            case 'suspend':
                return ['Suspended', 'status-color-red'];
            default: //case '' || 'inactivate' || null || undefined:
                return ['QID not activated', 'status-color-purple'];
        }
    }

    // useEffect(()=>{
    //     setInput(()=> {
    //         return({...input, ...initial_values})
    //     });
    //     setUserList(()=>{
    //         return group_data.users.map(u=>({...u, checked: true}))
    //     });
    // }, [group_data]);

    useEffect(()=>{
        if (openModal === false) {
            setInput(()=> {
                return({...input, ...initial_values})
            });
        }
    }, [openModal]);

    useEffect(()=>{
        onCheckBoxListChanged();
    }, [userList]);



    return (
        // <>
            <ModalComponent isOpen={openModal} onClose={closeModal} onSubmit={onSubmit} title={t('@Create group@')} input={input} okText={t('@Create@')} ref={modal}>
                <div className="dialog-content">
                    <form>
                        <TextInputComponent label={t('@Group name@')} field_name={'group_name'} input={input} setInput={setInput} place_holder={t('@Please input group name@')} format={LENGTH_FORMAT(50)}/>
                        <TextInputComponent label={t('@Group description@')} field_name={'description'} input={input} setInput={setInput} place_holder={t('@Please input group description@')} format={GROUP_DESCRIPTION_FORMAT(0, 50)}/>
                    </form>
                    <div className="dialog-content-divide !mt-32 !mb-8"/>
                    <div className="dialog-content-header !mt-16 !mb-24">{t('@Members@')}</div>
                    <div className="toolbar justify-content-end">
                        <div className="comp-search">
                            <img src={ic_search_svg} alt="" />
                            <div className="comp-input">
                                <input type="text" value={groupQueryFilter} onChange={e=>setGroupQueryFilter(e.target.value)} placeholder="" />
                            </div>
                        </div>
                    </div>
                    {/* <!-- 群組列表 -->*/}
                    <div className="flexbox-table">
                        <div className="flexbox-thead">
                            <div className="thead-cell select-cell">
                                {/* <!-- 非全選的話 comp-checkbox 請加上 class： indeterminate -->*/}
                                <div className="comp-checkbox no-label">
                                    <input type="checkbox" id="cb-all" checked={checkAll} onChange={(e)=>toggle_check_all(e)}/>
                                    <label htmlFor="cb-all" className="comp-label"> </label>
                                </div>
                            </div>
                            <div className="thead-cell !w-80">
                                <div className="sort sort-disabled">
                                    <span className="sort-label">{t('@QID (Email)@')}</span>
                                    <span className="sort-arrow"><img src={ic_arrow_drop_down} alt=""/></span>
                                </div>
                            </div>
                            <div className="thead-cell !w-20">
                                <div className="sort sort-disabled">
                                    <span className="sort-label">{t('@Account status@')}</span>
                                    <span className="sort-arrow"><img
                                        src={ic_arrow_drop_down} alt=""/></span>
                                </div>
                            </div>
                        </div>
                        <OverlayScrollbarsComponent
                            className="flexbox-tbody overlay-scroll os-host-flexbox">
                            {userList && userList.filter(
                                g=>g.display_name?.match(new RegExp(groupQueryFilter, 'i')) ||
                                        g.email?.match(new RegExp(groupQueryFilter, 'i'))  ||
                                        g.qid?.match(new RegExp(groupQueryFilter, 'i'))
                            ).map((user, index)=>{
                                return(
                                    <div className="flexbox-trow" key={user.id}>
                                        <div className="tbody-cell select-cell">
                                            <div className="comp-checkbox no-label">
                                                <input type="checkbox" id={`cb-${user.id}`} checked={user.checked}
                                                       onChange={async ()=>{
                                                           await toggle_user_remove_list(user)
                                                       }}
                                                />
                                                <label htmlFor={`cb-${user.id}`} className="comp-label"> </label>
                                            </div>
                                        </div>
                                        <div className="tbody-cell !w-80">
                                            <div className="admin-info">
                                                <div className="account-img">
                                                    <div className={`avatar ${user.avatars ? '' : 'no-avatar'}`}>
                                                        {!user.avatars && <span>{user.display_name != undefined ? user.display_name?.[0] : user.qid?.[0] || user.email?.[0]}</span>}
                                                        {user.avatars && <img src={`${url.get_acc_url()}/avatar/${user.id}/s`} alt=""/>}
                                                    </div>
                                                </div>
                                                <div className="account-info">
                                                    <div className="name">{user.display_name}</div>
                                                    <div className="mail">{user.email || user.qid}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tbody-cell !w-20">
                                            <div className={`status-tag ${get_status(user.status)?.[1]} no-border !pl-0 !pr-0 disable-event`}>
                                                <span className="label">{t(`@${get_status(user.status)?.[0]}@`)}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </OverlayScrollbarsComponent>
                    </div>
                </div>
            </ModalComponent>
        // </>
    );
};

export default GroupCreateModalComponent;